import RelatedDetail from '../_detail';

// 関連サイト詳細(JA)。本文・画像は src/data/related/the-butler.ts、FAQ は src/data/faq.json(/related/the-butler)。
export default function RelatedTheButlerPage() {
  return <RelatedDetail slug="the-butler" lang="ja" />;
}
